import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppdataService } from '../../../../service/appdata.service';
import { AiService } from '../../../../service/ai.service';
import { UploadService } from '../../../../service/upload.service';
import { UserdataService } from '../../../../service/userdata.service';

@Component({
  selector: 'app-basicinfos',
  standalone: false,

  templateUrl: './basicinfos.component.html',
  styleUrl: './basicinfos.component.scss'
})
export class BasicinfosComponent implements AfterViewInit, OnInit {
  @Input() lang: string = 'en';
  @Input() companyData: any;
  @Output() companyChange = new EventEmitter<any>();

  companyForm: FormGroup;
  industryOptions: any[] = [];
  loading: boolean = false;
  pitchdeckFile: any;
  files: any = [];
  allowedTypes: any;
  fileInputAccepts: any;
  defaultProjectId: any;

  constructor(
    private appData: AppdataService,
    private fb: FormBuilder,
    private ai: AiService,
    private upload: UploadService,
    private user: UserdataService
  ) {

    this.companyForm = this.fb.group({
      name: [],
      industry: [],
      mission: [],
      webpage: []
    });
  }
  ngOnInit(): void { }
  ngAfterViewInit(): void {
    this.loadData();
  }

  ngOnChanges(): void {
    this.prepareIndustryOptions();
    this.patchCompanyForm();
  }

  async deleteFile(file: any) {
    // if (file.error) {
    //   this.files = this.files?.filter((f: any) => f.fileId !== file.fileId);
    //   return;
    // }
    let result = await this.upload.deleteFile(file.fileId);
    if (result === false) { return; }
    console.log('deleteFile', result, file, this.files);
    if (this.pitchdeckFile?.fileId === file.fileId) {
      this.pitchdeckFile = null;
    }
    this.files = this.files?.filter((f: any) => f.fileId !== file.fileId);
  }

  async onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (!inputElement.files || inputElement.files.length === 0) {
      return;
    }
    this.uploadFiles(Array.from(inputElement.files));
  }


  async uploadFiles(files: any) {
    for await (const file of files) {

      // ToDo: check if filename exists in files
      if (this.files?.find((f: any) => f.name === file.name)) {
        file.error = true;
        file.errorText = "File already exists";
      }

      if (!this.allowedTypes.includes(file.type)) {
        file.error = true
        file.errorText = "Filetype not allowed";
      }

      if (file.size > 5000000) {
        file.error = true;
        file.errorText = "File is too big max 5MB";
      }

      this.files.unshift(file)
    }

    if (files?.length !== 1) return;

    for (let i = 0; i < files.length; i++) {
      if (files[i].error) { continue; }
      this.upload.uploadFile(files[i], this.defaultProjectId, 'PITCHDECK').subscribe((percentage) => {
        for (let j = 0; j < this.files.length; j++) {
          if (this.files[j].name === files[i].name) {
            this.files[j].percentage = percentage;
          }
        }
      });

    }
  }
  async optimizeMission() {

    if (this.companyForm.value.mission === '') {
      console.log('asdasd', this.companyForm.value.mission);

      return;
    }
    this.loading = true;
    let result: any = await this.ai.defaultAiService('OPTIMIZE-MISSION', this.companyForm.value.mission);
    this.loading = false;
    if (result === false) return;
    this.companyForm.patchValue({
      mission: result.message
    });
  }
  async saveChanges() {
    if (this.companyForm.invalid) {
      return;
    }

    this.companyChange.emit(this.companyForm.value);
  }

  private prepareIndustryOptions() {
    const languageKey = this.lang === 'de' ? 'name_de' : 'name_en';
    const byLabel = new Map<string, any>();

    for (const item of this.appData?.industryTypes ?? []) {
      const label = (item?.[languageKey] || '').trim();
      if (!label) {
        continue;
      }
      if (!byLabel.has(label.toLowerCase())) {
        byLabel.set(label.toLowerCase(), item);
      }
    }

    this.industryOptions = Array.from(byLabel.values()).sort((a, b) => {
      const aLabel = (a?.[languageKey] || '').toLowerCase();
      const bLabel = (b?.[languageKey] || '').toLowerCase();
      return aLabel.localeCompare(bLabel, this.lang || 'en');
    });
  }

  private patchCompanyForm() {
    if (!this.companyData) {
      return;
    }

    this.companyForm.patchValue({
      ...this.companyData,
      industry: this.companyData?.industry || this.companyData?.industryId || null,
    }, { emitEvent: false });
  }

  async loadData() {
    this.prepareIndustryOptions();
    this.patchCompanyForm();

    this.companyForm.valueChanges.subscribe(() => {
      this.saveChanges();
    });
    this.defaultProjectId = await this.user?.getDefaultProjectId();

    this.allowedTypes = this.upload.allowedTypes;
    this.fileInputAccepts = this.allowedTypes.join(',');

    this.user.data.subscribe(async (data) => {
      if (!data?.ragFiles) return;
      let projectFiles = data.ragFiles?.find((f: any) => f.projectId === this.defaultProjectId);
      console.log('projectFiles', projectFiles);

      if (projectFiles) {
        this.pitchdeckFile = projectFiles.files.find((f: any) => f.fileType === 'PITCHDECK');
        console.log('PITCHDECK', this.pitchdeckFile);
      }

    });
  }
}
